import axios from "axios";
import { handleHttpErrors } from "../../../modules/http";

import {
  orderType,
  tablePageSizes,
} from "../../ui-library/CustomTable/constants";

// Constants
const SET_HISTORY = "SET_STUDY_STATUS_HISTORY";
const RESET_STATE = "RESET_STATE";
const LOGOUT = "LOGOUT";

// Acessors
const getHistory = (state) => state?.history;
const getTotalItems = (state) => state?.totalItems;
const getSearchedParams = (state) => state?.searchedParams;

// Default state
const initialState = {
  history: [],
  totalItems: null,
  searchedParams: {
    page: 0,
    limit: tablePageSizes[0],
    search: "",
    orderBy: "date",
    order: orderType.DESC,
  },
};

export const studyStatusHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_HISTORY:
      const { data } = action;
      return {
        ...state,
        history: data.data,
        totalItems: data.records,
        searchedParams: action.searchedParams,
      };
    case RESET_STATE:
      return initialState;
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

const fetchStudyStatusHistory =
  (studyEnrollmentID, searchParameters) => async (dispatch) => {
    const params = {
      ...searchParameters,
      studyEnrollmentId: studyEnrollmentID,
    };

    return axios
      .get(`/api/study/enrollment/history`, { params })
      .then(({ data }) => {
        dispatch({
          type: SET_HISTORY,
          data: data,
          searchedParams: searchParameters,
        });
      })
      .catch((error) => {
        const defaultMessage = error.response?.data
          ? error.response.data
          : "There was an error while trying to fetch study status history!";

        return handleHttpErrors(error.request?.status, {
          default: defaultMessage,
        });
      });
  };

export const resetState = () => (dispatch) => {
  dispatch({ type: RESET_STATE });
};

export const mapStateToProps = (state) => {
  return {
    history: getHistory(state),
    totalItems: getTotalItems(state),
    searchedParams: getSearchedParams(state),
  };
};

export const mapDispatchToProps = {
  fetchStudyStatusHistory,
  resetState,
};
